// @flow

import * as React from 'react';

import { useNavigate } from 'react-router-dom';

import { selectCartUUID } from '@gandi/cart';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Text, PopoverIcon, Button } from '@gandi/ui';

import { withRouter } from 'src/helpers/withRouter';
import { useAppSelector } from 'src/hooks/useAppSelector';

import type { ExtendedSuggestion } from '../../DomainCreate/types';
import type { WithRouterProps } from '../../types';

import DomainIntro from './DomainIntro';

import styles from './Domains.scss';

export type InjectedProps = {
  ...WithRouterProps<>,
};

export type OwnProps = {
  childRef: React.ElementRef<any>,
  application?: ApplicationSummary,
  handleChooseDomain: (value: ExtendedSuggestion) => Promise<void>,
};

export type Props = {
  ...InjectedProps,
  ...OwnProps,
};

function Domains({
  childRef,
  application,
  handleChooseDomain,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const navigate = useNavigate();

  const cartId = useAppSelector(selectCartUUID);

  return (
    <div
      className={styles.whDomainsContainer}
      ref={childRef}
      id="choose-a-domain"
    >
      <Base marginBottom="base">
        <DomainIntro
          application={application}
          handleChooseDomain={handleChooseDomain}
        />
      </Base>
      <Base flex flexAlignItemsCenter>
        <Text tagName="p">
          {mapTags(
            __('Do you already have a domain name you want to use? [[link:]]'),
            () => ({
              link: (
                <Button
                  kind="link"
                  type="button"
                  onClick={() => navigate(`/cart/${cartId}/overview`)}
                >
                  {__('Continue')}
                </Button>
              ),
            }),
          )}
        </Text>
        <PopoverIcon icon="infoWire" id="skp_hasdomain">
          {__(
            'Do you want to use this hosting with one of your existing domains managed by Gandi or another registrar? No worries, you will be able to do this once your hosting has been purchased.',
          )}
        </PopoverIcon>
      </Base>
    </div>
  );
}

export default (withRouter(Domains): React.ComponentType<OwnProps>);
